/**
 * Links from the realm's email messages: `#reset=CODE` (choose a new password) and `#verify=CODE`
 * (confirm an email address). The code is in the fragment, so it never reaches a web server or
 * a Referer header. It is taken out of the address bar at once and kept for this tab until the
 * Battle.net log-in screen uses it (the game files may have to be loaded first).
 */
export interface AccountLink {
  kind: 'reset' | 'verify';
  code: string;
}

const KEY = 'd2o.accountLink';

/** Moves a reset/confirm code from the address bar into this tab's storage. Call once at boot. */
export function captureAccountLink(): void {
  const m = /^#(reset|verify)=([A-Za-z0-9_-]{16,64})$/.exec(location.hash);
  if (!m) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ kind: m[1], code: m[2] }));
  } catch {
    /* storage off: the code can still be typed in */
  }
  history.replaceState(null, '', `${location.pathname}${location.search}`);
}

export function pendingAccountLink(): AccountLink | null {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as AccountLink | null;
    return v && (v.kind === 'reset' || v.kind === 'verify') && typeof v.code === 'string' ? v : null;
  } catch {
    return null;
  }
}

export function clearAccountLink(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing kept */
  }
}
